import React, { useEffect, useState } from "react";
import { ClientsPageWrapper } from "./clientsPage.styled";
import SideMenuBar from "./components/sideMenuBar";
import styled from "styled-components";
import { Outlet } from "react-router-dom";
import ComapnyDetails from "../companyDetails/comapnyDetails";
import { useDispatch, useSelector } from "react-redux";
import { SagaActions } from "../../redux/actionTypes";
import { RootState } from "../../redux/store";
import RenderIf from "../../components/renderIf";

export const ClientsPage = () => {
  const Dispatch = useDispatch();
  const { clients } = useSelector((_state: RootState) => _state);

  const [selectedCompanyID, setselectedCompanyID] = useState({});

  useEffect(() => {
    Dispatch({ type: SagaActions.ADD_CLIENTS_LIST });
  }, []);

  return (
    <ClientsPageWrapper>
      <ClientsPageContainer>
        <SideMenuBar
          onSelectCompany={(data) => setselectedCompanyID(data?.id)}
        />
        <PageConatiner>
          <RenderIf isShow={clients?.data?.length > 0}>
            <ComapnyDetails companyData={{ companyID: selectedCompanyID }} />
          </RenderIf>
          <RenderIf isShow={clients?.data?.length < 1}>
            <div className="h-100 d-flex align-items-center justify-content-center">
              <p className="text-secondary">-: No Data :-</p>
            </div>
          </RenderIf>
        </PageConatiner>
      </ClientsPageContainer>
    </ClientsPageWrapper>
  );
};

const ClientsPageContainer = styled.div`
  display: flex;
  flex: 1;
  /* border: 2px solid green; */
  overflow: auto;
`;

const PageConatiner = styled.div`
  background-color: white;
  flex: 1;
  flex-direction: column;
`;
